import { COL_OFFSET } from '@/domain/mitarbeiter/features/rotationsplan/constants';
import { Arbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/entities/Arbeitsbereich';
import { Mitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/entities/Mitarbeiter';
import { getColorsForMarkierung } from '@/domain/mitarbeiter/features/rotationsplan/utils/getColorForMarkierung';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';

interface Station {
  id: string;
  von: Date;
  bis: Date;
  abschnittId: string;
}

export class ArbeitsbereichStation implements Station {
  constructor({
    von,
    bis,
    arbeitsbereich,
    bereichsleiter,
    abschnittId,
    id,
  }: {
    id: string;
    von: Date;
    bis: Date;
    arbeitsbereich: Arbeitsbereich;
    bereichsleiter: Mitarbeiter;
    abschnittId: string;
  }) {
    this.id = id;
    this.von = von;
    this.bis = bis;
    this.arbeitsbereich = arbeitsbereich;
    this.bereichsleiter = bereichsleiter;
    this.abschnittId = abschnittId;
  }

  id: string;
  abschnittId: string;
  von: Date;
  bis: Date;
  arbeitsbereich: Arbeitsbereich;
  bereichsleiter: Mitarbeiter;

  getColStart(): number {
    const week = dayjs(this.von).isoWeek();
    const weekday = dayjs(this.von).isoWeekday();
    return (week - 1) * 7 + weekday + COL_OFFSET;
  }

  getColEnd(): number {
    const week = dayjs(this.bis).isoWeek();
    const weekday = dayjs(this.bis).isoWeekday();
    // Da grid-col-end exklusiv ist, müssen wir neben dem Offset noch mal 1 drauf rechnen
    return (week - 1) * 7 + weekday + COL_OFFSET + 1;
  }

  getFillColor(): string {
    return getColorsForMarkierung(this.arbeitsbereich.markierung).light;
  }

  getBorderColor(): string {
    return getColorsForMarkierung(this.arbeitsbereich.markierung).base;
  }
}

export class AbwesenheitsStation implements Station {
  constructor({
    von,
    bis,
    titel,
    abschnittId,
    id,
  }: {
    von: Date;
    bis: Date;
    titel: string;
    abschnittId: string;
    id: string;
  }) {
    this.von = von;
    this.bis = bis;
    this.titel = titel;
    this.abschnittId = abschnittId;
    this.id = id;
  }

  id: string;
  von: Date;
  bis: Date;
  titel: string;
  abschnittId: string;
}
